"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_dom_1 = tslib_1.__importDefault(require("react-dom"));
const CallControlUI_1 = tslib_1.__importDefault(require("../../../ui-lib/CallControl/CallControlUI"));
function CallControls({ attachToRef, isCallInProgress, renderCustomControls, renderCallMetaDisplay, classes, }) {
    if (attachToRef == null || !isCallInProgress)
        return null;
    const renderUI = () => (react_1.default.createElement(CallControlUI_1.default, { classes: classes, renderCustomControls: renderCustomControls, renderCallMetaDisplay: renderCallMetaDisplay }));
    return react_dom_1.default.createPortal(renderUI(), attachToRef);
}
exports.default = CallControls;
//# sourceMappingURL=CallControl.js.map